import React, {useEffect} from 'react';
import styles from './Scenario.module.scss'
import Globe from "../MainMenu/Globe/Globe";
import ContentBox from "../common/ContentBox/ContentBox";
import SegmentedSlider from "../SegmentedSlider/SegmentedSlider";
import DogEar from "../../../partials/DogEar/DogEar";
import Button from "../../../partials/Button";
import TabbedModal from "../TabbedModal/TabbedModal";
import OrbitMaker from "../OrbitMaker/OrbitMaker";
import OrbitMakerV2 from "../OrbitMakerV2/OrbitMaker";
import BigGlobe from "../common/BigGlobe/BigGlobe";
import _ from 'lodash';
import OrbitElementsSimulator from "../OrbitElementsSimulator/OrbitElementsSimulator";
import GroundData from "../GroundData/GroundData";
import {OrbitsContext} from "../Context/OrbitsContext";



function Scenario(props) {

    const [currentOrbitChoices, setCurrentOrbitChoices] = React.useState({})
    const [smaValues, setSmaValues]  = React.useState([])
    const [incValues, setIncValues]  = React.useState([])
    const [eccValues, setEccValues] = React.useState([])

    const [orbitColor, setOrbitColor] = React.useState();
    const [bigGlobeVariant, setBigGlobeVariant] = React.useState('normal')
    const [errorMsg, setErrorMsg] = React.useState()

   const [currentSection, setCurrentSection]  = React.useState(0)
   const [currentSelectedOrbit, setCurrentSelectedOrbit] = React.useState()

   const [isCorrectOrbitChoices, setIsCorrectOrbitChoices] = React.useState()
    const [currentFeedback, setCurrentFeedback] = React.useState({
        header: '',
        body: ''
    })

    const orbitsState = React.useContext(OrbitsContext)
    useEffect(() => {

        orbitsState.setCurrentGoBackCallback(undefined)
    }, [])
    useEffect( () => {
        if (sections[currentSection]?.sectionOptions?.isOutcome  === true) {
            setBigGlobeVariant(isCorrectOrbitChoices === true ? 'success' : 'failure')
        }
    }, [isCorrectOrbitChoices])

    useEffect( () => {
        if (!currentSelectedOrbit) return
        const getValues = aspect => {
            try {
                const orbitGroundData = orbitsState.groundData[currentSelectedOrbit.header.toLowerCase()]
                const aspectValues = [...new Set(orbitGroundData.map(d =>d[aspect]))]
                return aspectValues.sort( function (a, b) {
                    return a - b
                })

            } catch (e) {
                console.error("Invalid Orbit groundData for :" + currentSelectedOrbit.header.toLowerCase())
                console.log(e.message)
            }
            return [];
        }
        setSmaValues(getValues('sma'))
        setIncValues(getValues('inc'))
        setEccValues(getValues('ecc'))

    }, [currentSelectedOrbit])

   const sections =  props?.story.sections

    const handleSelectionChange = (index) => {
        setCurrentSelectedOrbit(props.orbits[index])
    }
    const handleSelectClick = () => {
        if (currentSection < sections.length-1) {
            setCurrentSection(currentSection + 1)
        }
        if (sections[currentSection]?.sectionOptions?.isOutcome  === true) {
            props.onContinue()
        }


    }
    const handleSliderChange = (value) => {

       setCurrentOrbitChoices(value)

    }
    React.useEffect(() => {
        console.log("CHECKING: ", {
            correctOrbitDataSMA: currentOrbitChoices.sma,
            correctOrbitDataEccentricity: currentOrbitChoices.eccentricity,
            correctOrbitDataInclination: currentOrbitChoices.inclination
        }, props.story?.correctOrbitData)
        setIsCorrectOrbitChoices(_.isEqual({
            correctOrbitDataSMA: currentOrbitChoices.sma,
            correctOrbitDataEccentricity: currentOrbitChoices.eccentricity,
            correctOrbitDataInclination: currentOrbitChoices.inclination
        }, props.story?.correctOrbitData))
    }, [currentOrbitChoices])

    React.useEffect( () => {
            const feedback  = isCorrectOrbitChoices ? sections[currentSection]?.correct : sections[currentSection]?.incorrect
            setCurrentFeedback(feedback)
    }, [currentSection, isCorrectOrbitChoices])
   return <div className={styles.Scenario}>
       {<div className="back-btn-container" style={{zIndex: 10}} onClick={() => {
           setCurrentSection(currentSection > 0 ? currentSection - 1 : currentSection)
       }}>
           <Button variant={'back'} text={'BACK'}/>
       </div>}
       {currentSelectedOrbit &&  sections[currentSection].sectionOptions?.orbitSelection === true && <Globe selected={currentSelectedOrbit?.header} orbits={props.orbits.map( o =>( {...o, selected: false, checked: false})) } show={[]} translateX={0} translateY={-150} />}

       <div className={styles.MainContainer}>
           <div className={styles.Content}>
               <div className={styles.ScenarioContent}>
                   {currentSelectedOrbit &&  sections[currentSection]?.sectionOptions?.scenarioDescription === true  &&
                   <ContentBox
                       style={{height:"450px"}}
                       variant="blueish"
                       fitContent={false}
                       title={'Scenario'}
                       htmlContent={props?.story?.body || 'Invalid content'}>
                   </ContentBox>}
               </div>
               <div className={styles.OrbitSelector}>
                   {currentSelectedOrbit &&  sections[currentSection]?.sectionOptions?.doBigGlobe === true &&
                    <BigGlobe
                       selected={currentSelectedOrbit?.header} orbits={props.orbits.map( o =>( {...o, selected: false, checked: false})) }
                       show={[]}
                       variant={bigGlobeVariant}
                       translateX={0}
                       translateY={0} />}
                   {sections[currentSection]?.sectionOptions?.orbitSelect === true && <SegmentedSlider
                       onChange={handleSelectionChange}
                       caption={'ORBIT SELECTOR'}
                       values={[...Array(props.orbits.length).keys()]}
                   />}
                   {sections[currentSection]?.sectionOptions?.orbitMaker === true &&
                          <>  <OrbitElementsSimulator
                              orbit={currentSelectedOrbit}
                              sma={currentSelectedOrbit?.orbitData?.sma || 0}
                              inc={currentSelectedOrbit?.orbitData?.inc || 0}
                              ecc={currentSelectedOrbit?.orbitData?.ecc || 0}
                              SMAValues={smaValues}
                              InclinationValues={incValues}
                              EccentricityValues={eccValues}
                                showSliders={sections[currentSection]?.sectionOptions?.doSliders === true}
                                onSlidersChange={handleSliderChange}
                                showGroundData={sections[currentSection]?.sectionOptions?.doGroundData === true}
                              orbitColor={orbitColor}

                              errorMsg={errorMsg}
                              onErrorClick={ () => setErrorMsg(undefined)}
                              onSlidersChange={(h) =>{
                                  // TODO: Hook Up Ground Data.
                                  if (!h.sma) return
                                  // setCurrentSelectedOrbitData(h)
                                  const orbitGroundData = orbitsState.groundData[currentSelectedOrbit.header.toLowerCase()]
                                  const smaTracks  = orbitGroundData.filter(
                                      t=> {
                                          return t.sma === h.sma &&
                                              t.ecc === h.eccentricity &&
                                              t.inc === h.inclination
                                      }
                                  )
                                  if (smaTracks.length < 1) {
                                      setOrbitColor(smaTracks.length < 1? "red": undefined)
                                      setErrorMsg(smaTracks.length < 1 ? "Adjust your SMA, inclination or eccentricity in order to view another orbit": undefined)
                                  } else {

                                      const failReason =  smaTracks.find( t => t.isGood === false && t.reason !== '')
                                      if (failReason) {
                                          setErrorMsg( failReason.reason )

                                      } else {
                                          setErrorMsg(undefined)
                                          setOrbitColor(undefined)
                                      }
                                  }



                              }
                              }

                          />

                          </>


                   }
               </div>
               <div className={styles.OrbitContent}>
                   <div className={styles.SectionHeader}>
                       {sections[currentSection].header}
                   </div>
               {currentSelectedOrbit &&  sections[currentSection].sectionOptions?.orbitDescription === true &&
               <ContentBox title={currentSelectedOrbit.name} htmlContent={currentSelectedOrbit?.body || 'invalid orbit info'}>
               </ContentBox>}
               {currentSelectedOrbit &&  sections[currentSection].sectionOptions?.orbitTabs === true &&  (<><div className={styles.Title}>Explore the orbit facts and continue</div>
                   <TabbedModal data={currentSelectedOrbit} />

               </>)}}
               {sections[currentSection]?.sectionOptions?.orbitMaker === true &&
               <TabbedModal data={currentSelectedOrbit} doSlider={false} tabsOnTop={true} onSliderChange={handleSliderChange}/>}
                   {sections[currentSection]?.sectionOptions?.isOutcome === true &&  <ContentBox
                    title={currentFeedback?.header || 'Invalid Correct header'}
                    variant={isCorrectOrbitChoices ? 'success' : 'failure' }
                    htmlContent={currentFeedback?.body || 'Invalid Correct body'}
                    fitContent={true}
                   >
                   </ContentBox>}
               </div>
            </div>
           <div className={styles.ActionBar} >
               {sections[currentSection]?.resetValue !== -1  && <Button
                   text={sections[currentSection].retryButton || 'RETRY'}
                   onClick={()=> setCurrentSection(sections[currentSection]?.resetValue || 0)}>
                    </Button>}
               {currentSelectedOrbit && <Button
                   onClick={handleSelectClick}
                   text={sections[currentSection].nextButton ||  'NEXT'}
               ></Button>}

           </div>
        </div>
   </div>
}

export default Scenario;

